const u = ["en-au"], U = (r = {}) => {
  const { origin: e, language: t, path: s = "/chat", message: n, newCase: g, ref: i } = r, l = !!e && (!t || u.includes(t));
  let a = s;
  if (l && e)
    try {
      a = `${new URL(e).origin}${s}`;
    } catch {
      a = s;
    }
  const c = new URLSearchParams();
  g && c.set("newCase", "true"), n && c.set("ask", n), i && c.set("ref", i.slice(0, 512));
  const o = c.toString();
  return o ? `${a}?${o}` : a;
}, w = (r = {}) => {
  const { origin: e, language: t } = r;
  if (!!e && (!t || u.includes(t)) && e)
    try {
      const n = new URL(e).origin;
      return { myCasesUrl: n, settingsUrl: `${n}/account` };
    } catch {
    }
  return { myCasesUrl: "/account", settingsUrl: "/account/edit" };
};
export {
  u as NEW_CHAT_COUNTRIES,
  w as getAccountUrls,
  U as getChatUrl
};
